import { defineNuxtPlugin } from 'nuxt/app'

/**
 * 处理 OAuth provider 回到业务页面后的 code、cookie 或未注册身份参数。
 * userlogin.html 仍由旧的微信回调流程独立处理，避免重复消费回调参数。
 */
export default defineNuxtPlugin({
  name: 'third-party-callback',
  dependsOn: ['shared-app-store', 'app-request-context'],
  async setup() {
    const route = useRoute()

    if (String(route.name || '').startsWith('userlogin')) {
      return
    }

    const hasThirdPartyIdentityCallback =
      Boolean(route.query.id || route.query.openId || route.query.openid || route.query.userId) &&
      Boolean(route.query.returnurl || route.query.from || route.query.fromurl)
    const hasThirdPartyCallback =
      route.query.type === 'login' ||
      Boolean(route.query.cookieValue || route.query.cookievalue || route.query.code || route.query.thirdpayload) ||
      hasThirdPartyIdentityCallback

    if (!hasThirdPartyCallback) {
      return
    }

    await useThirdPartyCallback().processThirdPartyCallback()
  },
})
